module.exports = __webpack_public_path__ + "img/ctrl-u-stub-down--.4b87d447.svg";